// extracted by mini-css-extract-plugin
module.exports = {"molecule__fieldset-header-container":"styles_molecule__fieldset-header-container__qP_7y","legend":"styles_legend__kKBXY","description":"styles_description__IVAut"};